import { gql } from "@apollo/client";

const GET_GESTION_ASISTENCIAL_PACIENTE_BY_ID = gql`
    query pacienteById($idPaciente: Int!) {
        pacienteById(idPaciente: $idPaciente) {
            nombre
            apellido
            idTipoDocumento
            numeroDocumento
            fechaNacimiento
            sexo
            codSAPPaciente
            familiar
            familiarTelefono
            telefonoContacto
            mail
            latitud
            longitud
            telefonoUbicacion
            observacionesUbicacion
        }
    }
`;

export default GET_GESTION_ASISTENCIAL_PACIENTE_BY_ID;

export const adaptPacienteGestionAsistencial = (pacienteAsistencial) => {
  return {
    nombre: pacienteAsistencial?.nombre,
    apellido: pacienteAsistencial?.apellido,
    nroAfiliado: '',
    tipoDoc: pacienteAsistencial?.idTipoDocumento,
    nroDocumento: pacienteAsistencial?.numeroDocumento,
    fechaNacimiento: pacienteAsistencial?.fechaNacimiento,
    sexo: pacienteAsistencial?.sexo,
    codigoSap: pacienteAsistencial?.codSAPPaciente,
    familiar: pacienteAsistencial?.familiar,
    familiarTelefono: pacienteAsistencial?.familiarTelefono,
    telefonoContacto: pacienteAsistencial?.telefonoContacto,
    mail: pacienteAsistencial?.mail,
    latitud: pacienteAsistencial?.latitud,
    longitud: pacienteAsistencial?.longitud,
    telefonoUbicacion: pacienteAsistencial?.telefonoUbicacion,
    observacionesUbicacion: pacienteAsistencial?.observacionesUbicacion

  };
};